export default {
  dashboard: 'Dashboard',

  'dashboard.totalWorkOrderAverageTicket': 'Average Ticket Total (Work Order)',
  'dashboard.monthlyTotalWorkOrderAverageTicket':
    'Monthly Average Ticket Total (Work Order)',
  'dashboard.monthlyTotalWorkOrderAverageRealTicket':
    'Monthly Average Real Ticket Total (Work Order)',
  'dashboard.monthlyDeliveries': 'Monthly Deliveries',
  'dashboard.delayedDeliveries': 'Delayed Deliveries',

  'dashboard.partsAndServicesReport': 'Parts and Services Report',
  'dashboard.partsAndServicesReport.partsAndServicesTotal':
    'Parts/Services Total (R$)',

  'dashboard.financialReport': 'Financial Report',
  'dashboard.financialReport.incomeAndExpensesRelation':
    'Income/Expenses Relation (R$)',

  'dashboard.averageTicketReport': 'Average Ticket Report',
  'dashboard.averageTicketReport.averageTicketPartsAndServices':
    'Average Ticket (Parts x Services) (R$)',

  'dashboard.lastSixMonths': 'Last six months',

  'dashboard.team': 'Team',

  'dashboard.averageTicket.modal.form.startDate.endDate': 'Start/End Date',
  'dashboard.averageTicket.modal.form.types': 'Types',
  'dashboard.averageTicket.modal.form.courtesy': 'Courtesy',
  'dashboard.averageTicket.modal.form.insideCourtesy': 'Inside (Courtesy)',
  'dashboard.averageTicket.modal.form.warranty': 'Warranty',
  'dashboard.averageTicket.modal.form.work_order': 'Work Order',
  'dashboard.averageTicket.modal.form.total_loss': 'Total Loss',
  'dashboard.averageTicket.modal.form.return': 'Return',
  'dashboard.averageTicket.modal.form.revision': 'Revision',
  'dashboard.averageTicket.modal.form.companies': 'Companies',
};
